import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import RHService from '../../../services/rh'
import Concurso from './concurso';

const ListarConcursos = () => {

    const [concursos, setConcursos] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchConcursos() {
        const response = await RHService.listarConcursos();
        if (response.data.length >= 1) {
            setConcursos(response.data)
            setVazio(false)
        } else {
            setConcursos([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchConcursos();
    }, []);

    return (
        <Fragment>
            <Alert variant='warning'>Informamos que o último concurso realizado pela Prefeitura Municipal de Macuco foi no ano de 2010, sendo seu último edital de convocação publicado no ano de 2013. Até a presente data, não foram realizados novos concursos. Por favor, atente-se a essas datas ao realizar sua busca!</Alert>
            <Fragment>
                <FormBusca
                    setConcursos={setConcursos}
                    setVazio={setVazio}
                    fetchConcursos={fetchConcursos}
                    concursos={concursos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Não foram divulgados editais de convocação ou editais de abertura no período selecionado. Informamos que o último concurso realizado pela Prefeitura Municipal de Macuco foi no ano de 2010, sendo seu último edital de convocação publicado no ano de 2013. Por favor, atente-se a essas datas ao realizar sua busca!</Alert>
            </Fragment> :
                <Fragment>
                    <h5>Editais de Concursos Públicos já realizados pela Prefeitura</h5>
                    <Row xs={1}>
                        {concursos.map((conc, index) =>
                            <Concurso
                                conc={conc}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarConcursos;